// utils/secureApiRequest.js
import axiosInstance from '../interceptor/intercetptor-inctence';
import { encryptAESKeyWithRSA, encryptRequestData, prepareSecureFormData } from './encryptionService'; // path to your encryption logic

const AES_KEY = process.env.REACT_APP_AES_KEY; // Your AES Key

//Send encrypted raw JSON request using AES + RSA + HMAC headers.
/**
 * Send encrypted request using AES + RSA + HMAC headers.
 * @param {'post' | 'put' | 'patch' | 'get'} method - HTTP method
 * @param {string} url - API endpoint
 * @param {object} body - Plain JSON object
 * @returns {Promise}
*/
export const secureApiRequest = async (method, url, body = {}) => {
	let options = { method, url };

	if (method.toLowerCase() === 'get') {
		const aesKey = AES_KEY; // or generate dynamically if needed
		const encryptedAESKey = encryptAESKeyWithRSA(aesKey);

		options.headers = {
			"X-AES-KEY": encryptedAESKey,
			"ngrok-skip-browser-warning": "69420"
		};
	} else {
		const { body: encryptedBody, headers: secureHeaders } = await encryptRequestData(body);
		options.data = encryptedBody;
		options.headers = { ...secureHeaders };
	}

	return axiosInstance(options);
};

//Send encrypted form data request using AES + RSA + HMAC headers.
export const secureApiFormDataRequest = async (method, url, data, files = [], token = null) => {
	const { formData, headers } = await prepareSecureFormData(data, files);

	const customHeaders = {
		...headers,
	};

	if (token) {
		customHeaders['Authorization'] = `Bearer ${token}`;
	}

	return axiosInstance({
		method,
		url,
		data: formData,
		headers: customHeaders,
	});
};
